export default __webpack_public_path__ + "static/media/ch4.dbd65e6f.svg";